export default "__VITE_ASSET__DnEaJnjX__"